import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { SealCheck, CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { api, formatApiError } from "../../lib/api";
import { ExportPaymentsButton } from "./ExportPayments";

const PERIODS = [["today", "Today"], ["week", "This week"], ["month", "This month"]];
const CARDS = [
  { k: "prepaid", label: "Prepaid", hint: "by payment date", Icon: SealCheck, cls: "text-[#2D5A27] bg-[#E8F3E5]" },
  { k: "paid", label: "Paid", hint: "by payment date", Icon: CheckCircle, cls: "text-[#15803D] bg-[#DCFCE7]" },
  { k: "outstanding", label: "Outstanding", hint: "by service date", Icon: WarningCircle, cls: "text-[#B42828] bg-[#FDE2E4]" },
];
const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export function RevenueSummary({ refreshKey }) {
  const [period, setPeriod] = useState("today");
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/service-requests-stats/payments?period=${period}`)
      .then(r => setData(r.data)).catch(e => toast.error(formatApiError(e)));
  }, [period, refreshKey]);

  return (
    <div className="bg-white border border-[#E5E2D9] rounded-md p-4 mb-4" data-testid="revenue-summary">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-1" role="tablist">
          {PERIODS.map(([k, l]) => (
            <button key={k} onClick={() => setPeriod(k)} data-testid={`revenue-period-${k}`}
                    className={`h-8 px-3 rounded-md text-xs font-medium transition-colors ${period === k ? "bg-[#1A1A1A] text-white" : "bg-[#F7F6F2] text-[#5C5A55] hover:bg-[#EFEDE6]"}`}>
              {l}
            </button>
          ))}
          {data && <span className="ml-2 text-[11px] text-[#8A8780] font-mono">{data.from_date}{data.to_date !== data.from_date ? ` → ${data.to_date}` : ""}</span>}
        </div>
        <ExportPaymentsButton url="/service-requests-export/payments.csv" testid="sr-export"
                              from={data?.from_date} to={data?.to_date}/>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
        {CARDS.map(c => (
          <div key={c.k} className="flex items-center gap-3 p-3 rounded-md border border-[#F0EDE4]" data-testid={`revenue-${c.k}`}>
            <div className={`w-10 h-10 rounded-md grid place-items-center ${c.cls}`}><c.Icon size={20} weight="duotone"/></div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#8A8780]">{c.label} <span className="normal-case tracking-normal">· {c.hint}</span></div>
              <div className="font-heading text-xl leading-tight" data-testid={`revenue-${c.k}-amount`}>{data ? inr(data[c.k].amount) : "…"}</div>
              <div className="text-[11px] text-[#5C5A55]" data-testid={`revenue-${c.k}-count`}>{data ? `${data[c.k].count} request${data[c.k].count === 1 ? "" : "s"}` : ""}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
